import defaultReducer from "./defaultReducer";

export default defaultReducer('REMOVE_MACHINE', []);